(() => {
  function initGuideLibrary(root) {
    if (root.dataset.guideReady === 'true') return;
    root.dataset.guideReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-guide-card]'));
    const input = root.querySelector('[data-guide-search]');
    const clear = root.querySelector('[data-guide-clear]');
    const empty = root.querySelector('[data-guide-empty]');
    const count = root.querySelector('[data-guide-count]');
    if (!input || !cards.length) return;
    const initialCount = count.textContent;
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const index = cards.map(card => normalize(card.dataset.guideText || ''));
    function filter() {
      const terms = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
      let visible = 0;
      cards.forEach((card, i) => {
        const matches = terms.every(term => index[i].includes(term));
        card.hidden = !matches;
        if (matches) visible++;
      });
      clear.hidden = input.value.length === 0;
      empty.hidden = visible !== 0;
      count.textContent = terms.length ? `${visible} ${visible === 1 ? 'guide' : 'guides'} found` : initialCount;
    }
    function reset() { input.value = ''; filter(); input.focus(); }
    root.querySelector('[data-guide-search-wrap]').hidden = false;
    input.addEventListener('input', filter);
    input.addEventListener('keydown', event => { if (event.key === 'Escape') reset(); });
    clear.addEventListener('click', reset);
    root.querySelector('[data-guide-reset]').addEventListener('click', reset);
  }
  document.querySelectorAll('[data-guide-library]').forEach(initGuideLibrary);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-guide-library]').forEach(initGuideLibrary);
  });
})();
